import { Link } from 'react-router-dom';
import type { BuildingZone } from '@kaeliux/shared';
import { usePlanetView } from '../../contexts/PlanetViewContext';

export interface SurfaceListViewLinkProps {
    /** Zone currently under the viewport centre — the list view lands on this zone's page. */
    activeZone: BuildingZone;
}

/**
 * DS-18 scope item 2's "List view" affordance: a persistent way off the
 * surface back onto the zone list, for players who prefer (or need, see
 * the small-height fallback in `PlanetPage`) the list over the stage.
 * Docked top-right of the stage so it never competes with the bottom
 * `ZoneStrip`/dock for space.
 */
export function SurfaceListViewLink({ activeZone }: SurfaceListViewLinkProps) {
    const { zoneRoute } = usePlanetView();
    return (
        <Link
            to={zoneRoute(activeZone)}
            data-testid="surface-list-view-link"
            className="absolute right-3 top-3 z-40 flex items-center gap-1.5 rounded-control border border-hairline-strong bg-space-950/70 px-3 py-1.5 text-label text-content-secondary backdrop-blur-sm hover:text-content-primary"
        >
            List view
        </Link>
    );
}

export default SurfaceListViewLink;
